import { useTranslation } from "react-i18next";

import { useSimpleCollapseState } from "capitalrx-components-2.0/lib/general";
import { Body } from "capitalrx-components-2.0/lib/typography";

import { ThemedCollapse } from "@/App/components";

export const MedicalDmrInfoSection = () => {
  const MEDICAL_INFO_TRANSLATION_PATH = "DIRECT_MEMBER_REIMBURSEMENT.medicalReimbursementInfo";
  const [expandedMedicalDmrInfo, onToggleExpandMedicalDmrInfo] = useSimpleCollapseState(true);
  const { t: translate } = useTranslation();

  return (
    <ThemedCollapse
      title={translate(`${MEDICAL_INFO_TRANSLATION_PATH}.title`)}
      expanded={expandedMedicalDmrInfo}
      onToggleExpand={onToggleExpandMedicalDmrInfo}
      alignCaret="left"
    >
      <Body>
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.letterhead`)}</b>
        {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.letterheadInfo`)}
        <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.providerInfo`)}</b>
        <br />
        <ul style={{ margin: "0rem", paddingInlineStart: "1.5rem" }}>
          <li>
            <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.nameOfProvider`)}</b>
            {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.md`)}
          </li>
          <li>
            <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.providerNpi`)}</b>
            {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.npiDescription`)}
          </li>
          <li>
            <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.providerAddress`)}</b>
          </li>
        </ul>
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.dob`)}</b> <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.dos`)}</b> <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.posCode`)}</b>
        {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.posCodeDescription`)}
        <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.diagnosisCode`)}</b>
        {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.diagnosisCodeDescription`)}
        <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.cptCode`)}</b>
        {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.cptCodeDescription`)}
        <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.billedCharges`)}</b>
        {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.billedChargesDescription`)}
        <br />
        <b>{translate(`${MEDICAL_INFO_TRANSLATION_PATH}.paidAmounts`)}</b>
        {translate(`${MEDICAL_INFO_TRANSLATION_PATH}.paidAmountsDescription`)}
      </Body>
    </ThemedCollapse>
  );
};
